class FiltersForm extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = [];
    
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    const filterForm = this.querySelector('form');
    filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    const resetBtn = document.querySelectorAll('.filters-form_remove-all');
    if(resetBtn){
      resetBtn.forEach(btn => {
        btn.addEventListener('click', this.resetFilters.bind(this));
      });
    }
    
    if(this.dataset.preserver) window.addEventListener('popstate', this.onHistoryChange.bind(this));
  }
  
  connectedCallback(){
    const form = this.querySelector('form');
    const params = this.createSearchParams(form);
    this.initParams = params ? params : '';

    FiltersForm.checkEmptyURL();
  }
  
  onHistoryChange(){
    if(event.state && this.cachedResults.length === 0){
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.add('--show-loader');
      
      const searchParams = event.state ? event.state.searchParams : this.initParams;
      const term = {params: searchParams};
      const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
      this.renderFetch(url, false, searchParams);
      
      return;
    }
    
    if(this.cachedResults && this.cachedResults.length > 0){
      const loader = document.querySelector('.filters-grid_loader');
      loader.classList.add('--show-loader');
      
      const searchParams = event.state ? event.state.searchParams : this.initParams;
      const term = {params: searchParams};
    
      if (this.cachedResults.some(key => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, false);
      
      } else{
        const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
        this.renderFetch(url, false, searchParams);
      }
    }
  }
  
  onSubmitHandler(){
    const loader = document.querySelector('.filters-grid_loader');
    loader.classList.add('--show-loader');
    
    const searchParams = this.createSearchParams(this.querySelector('form'));
    const url = `${window.location.pathname}?section_id=${this.dataset.section}&${searchParams}`;
    const term = {params: searchParams};
    
    if (this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)) {
      this.renderFromCache(this.cachedResults, term, true);
      
      return;
    }
    
    this.renderFetch(url, true, searchParams);
  }

  renderFetch(url, updateURLHash = false, searchParams){
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        this.renderProductGridContainer(html);
        this.renderActiveFiltersContainer(html);
        if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
        
        if(this.dataset.updateSelf === 'true'){
          this.renderFiltersList(html, true);
        
        } else{
          this.renderFiltersList(html);
        }
        
        const cacheObj = {params: searchParams, content: html};
        this.cachedResults.push(cacheObj);
        this.renderPriceUpdates(html);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        const loader = document.querySelector('.filters-grid_loader');
        loader.classList.remove('--show-loader');

        if(updateURLHash) this.updateURLHash(searchParams);
        document.dispatchEvent(new CustomEvent('rq:collection-grid-updated'));
      });
  }
  
  renderFromCache(cache, filter, updateURLHash = false){
    const cacheDataArr = cache;
    const cachedResults = cacheDataArr.find(results => results.params === filter.params);
    const html = cachedResults.content;
    
    this.renderProductGridContainer(html);
    this.renderActiveFiltersContainer(html);
    if(this.dataset.updateSelf === 'true') this.renderActiveCounts(html);
        
    if(this.dataset.updateSelf === 'true'){
      this.renderFiltersList(html, true);
    
    } else{
      this.renderFiltersList(html);
    }
    
    this.renderPriceUpdates(html);
    const loader = document.querySelector('.filters-grid_loader');
    loader.classList.remove('--show-loader');

    if(updateURLHash) this.updateURLHash(filter.params);
    document.dispatchEvent(new CustomEvent('rq:collection-grid-updated'));
  }

  createSearchParams(form) {
    const rangeSlider = document.querySelector('range-slider');
    const formData = new FormData(form);
    
    if(!rangeSlider) return new URLSearchParams(formData).toString();
    
    if(rangeSlider.dataset.load === 'false'){
      const gte = rangeSlider.querySelector('.min');
      const lte = rangeSlider.querySelector('.max');
      formData.delete(gte.getAttribute('name'));
      formData.delete(lte.getAttribute('name'));
    }
    return new URLSearchParams(formData).toString();
  }

  renderProductGridContainer(html){
    const currentGrid = document.getElementById('filters-grid');
    const newGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('filters-grid');

    if (!currentGrid || !newGrid) return;

    [
      'rqAvailabilityPatch',
      'rqBundleOnly',
      'rqPageSize',
      'rqInStockParam',
      'rqInStockValue',
      'rqInStockCount',
      'rqOutOfStockParam',
      'rqOutOfStockValue',
      'rqOutOfStockCount',
      'rqAvailabilityFilterActive',
      'rqAvailabilityManualSort',
      'rqAvailabilityEnabled'
    ].forEach((key) => {
      if (key in newGrid.dataset) {
        currentGrid.dataset[key] = newGrid.dataset[key];
      } else {
        delete currentGrid.dataset[key];
      }
    });

    delete currentGrid.dataset.rqAvailabilityPatchLoading;
    delete currentGrid.dataset.rqAvailabilityPatched;

    currentGrid.innerHTML = newGrid.innerHTML;
  }

  renderPriceUpdates(html){
    const priceRange = document.getElementById('price-range');
    if(!priceRange) return;

    const newHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('price-range');
    const newCounts = newHtml.querySelector('.range_wrapper');
    const oldCounts = priceRange.querySelector('.range_wrapper');

    const newMin = newHtml.querySelector('input[type="range"].min');
    const newMax = newHtml.querySelector('input[type="range"].max');
    const oldMin = priceRange.querySelector('input[type="range"].min');
    const oldMax = priceRange.querySelector('input[type="range"].max');
    if (oldMin && newMin) oldMin.value = newMin.value;
    if (oldMax && newMax) oldMax.value = newMax.value;

    if (oldCounts && newCounts) oldCounts.innerHTML = newCounts.innerHTML;
  }

  renderActiveFiltersContainer(html){
    document.querySelector('.filters-head').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filters-head').innerHTML;
  }

  renderActiveCounts(html){
    document.querySelector('.filter-header_results-text').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.filter-header_results-text').innerHTML;
  }

  renderFiltersList(html, collapsible = null){
    let filterWidgets = document.querySelectorAll('.filter-widget--list');
    let selector = '.filter-widget--list';
    if(collapsible){
      filterWidgets = document.querySelectorAll('.filter-widget--update');
      selector = '.filter-widget--update';
    }
    
    filterWidgets.forEach((widget, index) => {
      widget.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelectorAll(selector)[index].innerHTML;
    });
  }
  
  updateURLHash(searchParams) {
    if(!searchParams) searchParams = this.initParams;
    
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  
  resetFilters(){
    event.preventDefault();
    let filterForm = document.querySelector('filters-form[data-preserver="true"] form');
    const inputs = filterForm.querySelectorAll('input');
    
    inputs.forEach(input => {
      input.checked = false;
      input.removeAttribute('checked');
    });
    
    const priceRange = document.querySelector('range-slider');
    if(priceRange) priceRange.resetRanges();
    
    filterForm.reset();
    filterForm.dispatchEvent(new Event('input'));
  }

  static checkEmptyURL(){
    const activeFacet = document.querySelector('button-filter-remove');
    if(activeFacet){
      const filters = document.querySelector('[data-check-on-empty]');
      if(filters){
        filters.removeAttribute('hidden');
        if(filters.previousElementSibling) filters.previousElementSibling.classList.remove('--hide-separator');
      }
    }
  }
}
customElements.define('filters-form', FiltersForm);

function toggleOverflowFilterList(button) {
  const listId = button.getAttribute('aria-controls');
  const list = listId ? document.getElementById(listId) : null;
  if (!list) return;

  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  const nextExpanded = !isExpanded;
  const moreLabel = button.dataset.labelMore || 'Show more';
  const lessLabel = button.dataset.labelLess || 'Show less';

  button.setAttribute('aria-expanded', String(nextExpanded));
  button.textContent = nextExpanded ? lessLabel : moreLabel;

  if (nextExpanded) {
    list.removeAttribute('data-filter-list-collapsed');
  } else {
    list.setAttribute('data-filter-list-collapsed', 'true');
  }

  list.querySelectorAll('[data-filter-list-overflow-item]').forEach((item) => {
    item.hidden = !nextExpanded;
  });
}

class RangeSlider extends HTMLElement {
  constructor() {
    super();

    this.inputs = this.querySelectorAll('input[type="range"]');

    if(this.inputs){
      this.inputs.forEach(input => {
        input.addEventListener('input', this.onSlideWatch.bind(this));
      });
    }
  }

  connectedCallback() {
    this.querySelectorAll('input[type="number"]').forEach(el => {
      el.addEventListener('input', e => e.stopPropagation());
    });

    this.addEventListener('change', (e) => {
      if (e.target.type !== 'number') return;
      const minRangeInput = this.querySelector('input[type="range"].min');
      const maxRangeInput = this.querySelector('input[type="range"].max');
      if (!minRangeInput || !maxRangeInput) return;

      if (e.target.classList.contains('range_min')) {
        let val = Math.max(0, Math.min(parseFloat(e.target.value) || 0, parseFloat(maxRangeInput.value)));
        minRangeInput.value = val.toFixed(2);
        e.target.value = val.toFixed(2);
        minRangeInput.dispatchEvent(new Event('input', { bubbles: true }));
      } else if (e.target.classList.contains('range_max')) {
        let val = Math.min(parseFloat(maxRangeInput.max), Math.max(parseFloat(e.target.value) || parseFloat(maxRangeInput.max), parseFloat(minRangeInput.value)));
        maxRangeInput.value = val.toFixed(2);
        e.target.value = val.toFixed(2);
        maxRangeInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  onSlideWatch(){
    const minInput = this.querySelector('.min');
    const maxInput = this.querySelector('.max');
    const rangeMin = this.querySelector('.range_min');
    const rangeMax = this.querySelector('.range_max');

    var minVal = minInput.value;
    var maxVal = maxInput.value;

    if(minInput && minVal > maxVal-0){
      minInput.value = maxVal-0;
    }
    var minVal = parseFloat(minInput.value);
    rangeMin.value = minVal.toFixed(2);

    if(maxInput && maxVal-0 < minVal){
      maxInput.value = 0+ minVal;
    }
    var maxVal = parseFloat(maxInput.value);
    rangeMax.value = maxVal.toFixed(2);

    this.setAttribute('data-load', true);
  }

  resetRanges(){
    const minInput = this.querySelector('.min');
    const maxInput = this.querySelector('.max');
    const rangeMin = this.querySelector('.range_min');
    const rangeMax = this.querySelector('.range_max');

    var minVal = minInput.min;
    var maxVal = maxInput.max;

    minInput.value = minVal;
    maxInput.value = maxVal;
    rangeMin.value = parseFloat(minVal).toFixed(2);
    rangeMax.value = parseFloat(maxVal).toFixed(2);

    this.setAttribute('data-load', false);
  }
}
customElements.define('range-slider', RangeSlider);

class ButtonFilterRemove extends HTMLElement {
  constructor() {
    super();
    
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.submitRemoval.bind(this));
  }
  
  submitRemoval(){
    if(!this.dataset.for) return;
    
    const ref = this.dataset.for;
    const input = document.getElementById(ref);
    let filterForm = document.querySelector('.filters-sidebar form');
    if(this.dataset.updateId) filterForm = document.querySelector(`#${this.dataset.updateId}`);
    
    if(!input || !filterForm) return;
    
    if(ref === 'price-range'){
      const priceRange = document.getElementById(ref);
      priceRange.resetRanges();
      filterForm.dispatchEvent(new Event('input'));
      
      return;
    }
    
    input.checked = false;
    input.removeAttribute('checked');
    filterForm.dispatchEvent(new Event('input'));
  }
}

// Native sort select — delegated listener so it survives .filters-head AJAX re-renders
document.addEventListener('change', function(event) {
  if (!event.target.matches('.sort-select-native')) return;
  var sortInput = document.getElementById('sorting-input');
  var form = document.querySelector('.filters-sidebar filters-form form') || document.querySelector('#filters-form');
  if (!sortInput || !form) return;
  sortInput.value = event.target.value;
  form.dispatchEvent(new Event('input'));
});

document.addEventListener('click', function(event) {
  const toggle = event.target.closest('[data-filter-list-toggle]');
  if (!toggle) return;
  toggleOverflowFilterList(toggle);
});

customElements.define('button-filter-remove', ButtonFilterRemove);
